// frontend/modules/customer-notification/stores/reminder-scheduler-store.ts
import { create } from 'zustand';
import { FilterOptionDTO, QueryServiceInfo, ReminderConfigDTO } from '@/shared/api/model';

interface ReminderSchedulerState {
    // Configurations
    configs: ReminderConfigDTO[];
    isLoading: boolean;

    // Query Services
    queryServices: QueryServiceInfo[];
    filterOptions: FilterOptionDTO[];
    isLoadingServices: boolean;
    isLoadingFilters: boolean;

    // Form State
    formData: Partial<ReminderConfigDTO>;
    isFormVisible: boolean;
    isEditMode: boolean;
    activeConfigId: string | null;
    selectedQueryService: string | null;
    filterValues: Record<string, any>;

    // Actions
    setConfigs: (configs: ReminderConfigDTO[]) => void;
    setIsLoading: (isLoading: boolean) => void;
    setQueryServices: (services: QueryServiceInfo[]) => void;
    setFilterOptions: (options: FilterOptionDTO[]) => void;
    setIsLoadingServices: (isLoading: boolean) => void;
    setIsLoadingFilters: (isLoading: boolean) => void;
    setFormData: (data: Partial<ReminderConfigDTO>) => void;
    setIsFormVisible: (visible: boolean) => void;
    setIsEditMode: (isEdit: boolean) => void;
    setActiveConfigId: (id: string | null) => void;
    setSelectedQueryService: (service: string | null) => void;
    setFilterValues: (values: Record<string, any>) => void;
    resetForm: () => void;
}

const initialFormData: Partial<ReminderConfigDTO> = {
    name: '',
    description: '',
    templateName: '',
    platform: undefined,
    language: undefined,
    senderId: '',
    reminderHour: 8,
    reminderMinute: 0,
    enabled: true,
    retryCount: 3,
    //@ts-ignore
    queryServiceName: null,
    queryFilters: {}
};

export const useReminderSchedulerStore = create<ReminderSchedulerState>((set) => ({
    // State
    configs: [],
    isLoading: false,
    queryServices: [],
    filterOptions: [],
    isLoadingServices: false,
    isLoadingFilters: false,
    formData: { ...initialFormData },
    isFormVisible: false,
    isEditMode: false,
    activeConfigId: null,
    selectedQueryService: null,
    filterValues: {},

    // Actions
    setConfigs: (configs) => set({ configs }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setQueryServices: (queryServices) => set({ queryServices }),
    setFilterOptions: (filterOptions) => set({ filterOptions }),
    setIsLoadingServices: (isLoadingServices) => set({ isLoadingServices }),
    setIsLoadingFilters: (isLoadingFilters) => set({ isLoadingFilters }),
    setFormData: (formData) => set({ formData: { ...formData } }),
    setIsFormVisible: (isFormVisible) => set({ isFormVisible }),
    setIsEditMode: (isEditMode) => set({ isEditMode }),
    setActiveConfigId: (activeConfigId) => set({ activeConfigId }),
    setSelectedQueryService: (selectedQueryService) => set({ selectedQueryService }),
    setFilterValues: (filterValues) => set({ filterValues }),
    resetForm: () => set({
        formData: { ...initialFormData },
        isEditMode: false,
        activeConfigId: null,
        selectedQueryService: null,
        filterValues: {}
    })
}));